module.exports = __webpack_public_path__ + "caret-right.svg";